import services from "@/http";
import * as types from "./mutation-types";
import * as storage from "../storage";
import jsonToFormData from "@/helpers/functions/jsonToFormData";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetOportunidades", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async ({ commit }, search) => {
  commit(types.SET_LOADING, true);
  var oportunidades = {
    data: [],
    meta: {},
  };

  await services.oportunidades.get_all(search).then((res) => {
    oportunidades = res.data;
  });
  commit(types.SET_LOADING, false);
  return oportunidades;
};

export const ActionShow = async ({ dispatch, commit }, id) => {
  commit(types.SET_LOADING, true);
  await services.oportunidades.show({ id: id }).then((res) => {
    dispatch("ActionSetOportunidade", res.data.oportunidade);
  });
  commit(types.SET_LOADING, false);
};

export const ActionSave = async ({ dispatch, commit }, payload) => {
  commit(types.SET_LOADING, true);

  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }

  commit(types.SET_LOADING, false);
};

export const ActionStore = async ({ commit }, payload) => {
  await services.oportunidades.store(payload).then((res) => {
    commit(types.SET_OPORTUNIDADE, res.data.oportunidade);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.oportunidades
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_OPORTUNIDADE, res.data.oportunidade);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  commit(types.SET_LOADING, true);
  await services.oportunidades.delete({ id: id }).then(() => {
    commit(types.SET_OPORTUNIDADE, null);
  });
  commit(types.SET_LOADING, false);
};

export const ActionSetOportunidades = ({ commit, dispatch }, payload) => {
  commit(types.SET_OPORTUNIDADES, payload);
};

export const ActionSetOportunidade = ({ commit, dispatch }, payload) => {
  commit(types.SET_OPORTUNIDADE, payload);
  dispatch("ActionGetEstatisticas", payload.id);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionSetLoading = ({ commit }, loading) => {
  commit(types.SET_LOADING, loading);
};

export const ActionGetCurrencies = async () => {
  await services.oportunidades.currencies().then((response) => {
    return response.data.currencies;
  });
};

export const ActionNewOportunidade = ({ commit }) => {
  commit(types.SET_OPORTUNIDADE, {});
  commit(types.SET_OPORTUNIDADE_ESTATISTICA, {});
};

export const ActionGetOds = async ({ commit }, payload) => {
  let response = storage.getOdsToSelect();
  if (!response || !response.length) {
    await services.oportunidades.get_ods(payload).then((res) => {
      response = res.data;

      storage.setOdsToSelect(response);
    });
  }
  commit(types.SET_ODS, response);
  return response;
};

export const ActionGetModelMunicipios = async ({ commit }) => {
  return services.oportunidades
    .get_model_municipios()
    .then((content) => content.blob())
    .then((response) => URL.createObjectURL(response));
};

export const ActionGetAtualMunicipios = async ({ commit }, id) => {
  return services.oportunidades
    .get_base_municipios({ id })
    .then((content) => content.blob())
    .then((response) => URL.createObjectURL(response));
};

export const ActionImportarMunicipios = async ({ commit }, payload) => {
  const formData = jsonToFormData(payload);
  return services.oportunidades.update_municipios({ id: payload.id }, formData);
};

export const ActionGetStatusMunicipios = async ({ commit }, payload) => {
  return services.oportunidades.status_update_municipios(payload);
};

export const ActionImportarEmendas = async ({ commit }, payload) => {
  let response = {};
  await services.oportunidades.importar_emendas(payload).then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionValidarEmendas = async ({ commit }, payload) => {
  let response = {};
  await services.oportunidades.validar_emendas(payload).then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionGetAllModeloContrapartidas = async (
  { dispatch },
  payload
) => {
  let data = await dispatch("ActionFind", payload);
  await services.oportunidades
    .get_modelo_contrapartidas(payload)
    .then((res) => {
      commit(types.SET_MODELO_CONTRAPARTIDAS, data.data);
      dispatch("ActionSetPagination", data.meta);
    });
};

export const ActionGetTiposInstrumentos = async ({ commit }) => {
  let response = [];
  await services.oportunidades.get_tipos_instrumentos().then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionGetAllEditais = async ({ commit }) => {
  let response = [];
  await services.oportunidades.get_all_editais().then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionGetPlataformas = async (store) => {
  let response = [];
  await services.oportunidades.get_plataformas().then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionGetEstatisticas = async ({ commit }, id = null) => {
  let response = {};
  if (id) {
    await services.oportunidades
      .estatisticas_valores({ id: id })
      .then((res) => {
        response = res.data;
      });
  }
  commit(types.SET_OPORTUNIDADE_ESTATISTICA, response);
};

/**
 * Actions para Beneficios
 */

export const ActionGetAllBeneficios = async ({ commit }, search) => {
  var beneficios = {};

  await services.beneficios_services.get_all(search).then((res) => {
    beneficios = res.data;
  });

  return beneficios;
};

export const ActionSaveBeneficio = async ({ dispatch, state }, payload) => {
  let response = null;

  if (payload.id) {
    await services.beneficios_services
      .update({ id: payload.id }, payload)
      .then(({ data }) => {
        response = data.oportunidade_beneficio;
      });
  } else {
    await services.beneficios_services.store(payload).then(({ data }) => {
      response = data.oportunidade_beneficio;
    });
  }

  dispatch("ActionGetEstatisticas", state.oportunidade.id);
  return response;
};

export const ActionDeleteBeneficio = async ({ dispatch, state }, id) => {
  await services.beneficios_services.delete({ id: id });
  dispatch("ActionGetEstatisticas", state.oportunidade.id);
};

/**
 * Actions para Beneficios de Concedentes
 */

export const ActionGetAllBeneficiosConcedente = async ({ commit }, search) => {
  var beneficios = {};

  await services.beneficios_concedentes_services.get_all(search).then((res) => {
    beneficios = res.data;
  });

  return beneficios;
};

export const ActionSaveBeneficioConcedente = async (
  { dispatch, state },
  payload
) => {
  let response = null;

  if (payload.id) {
    await services.beneficios_concedentes_services
      .update({ id: payload.id }, payload)
      .then(({ data }) => {
        response = data.oportunidade_beneficio_concedente;
      });
  } else {
    await services.beneficios_concedentes_services
      .store(payload)
      .then(({ data }) => {
        response = data.oportunidade_beneficio_concedente;
      });
  }

  dispatch("ActionGetEstatisticas", state.oportunidade.id);
  return response;
};

export const ActionDeleteBeneficioConcedente = async (
  { dispatch, state },
  id
) => {
  await services.beneficios_concedentes_services.delete({ id: id });
  dispatch("ActionGetEstatisticas", state.oportunidade.id);
};

/**
 * Actions para Emendas
 */

export const ActionGetAllEmendas = async ({ commit }, search) => {
  var beneficios = {};

  await services.emendas_services.get_all(search).then((res) => {
    beneficios = res.data;
  });

  return beneficios;
};

export const ActionSaveEmenda = async ({ dispatch, state }, payload) => {
  let response = null;

  if (payload.id) {
    await services.emendas_services
      .update({ id: payload.id }, payload)
      .then(({ data }) => {
        response = data.oportunidade_emenda;
      });
  } else {
    await services.emendas_services.store(payload).then(({ data }) => {
      response = data.oportunidade_emenda;
    });
  }

  dispatch("ActionGetEstatisticas", state.oportunidade.id);
  return response;
};

export const ActionDeleteEmenda = async ({ dispatch, state }, id) => {
  await services.emendas_services.delete({ id: id });
  dispatch("ActionGetEstatisticas", state.oportunidade.id);
};

export const ActionList = async ({ commit }, payload) => {
  commit(types.SET_LOADING, true);
  await services.oportunidades.list(payload).then(({ data }) => {
    commit(types.SET_OPORTUNIDADESLIST, data.data);
    commit(types.SET_PAGINATION, data.meta);
  });
  commit(types.SET_LOADING, false);
};
